<template>
  <div class="smscate">
    <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button  type="primary" size="mini" @click="handleAddOpenShop">添加店铺</el-button>
          </el-col>
      </el-row>
    <el-table :data="shop_list" size="medium" style="width: 100%">
      <!-- <el-table-column label='id'>
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column> -->
      <el-table-column label='店铺名称'>
        <template slot-scope="scope">
          {{scope.row.shop_name}}
        </template>
      </el-table-column>
      <el-table-column label='店铺账号'>
        <template slot-scope="scope">
          {{scope.row.shop_account}}
        </template>
      </el-table-column>
      <el-table-column label='授权到期时间'>
        <template slot-scope="scope">
          {{scope.row.expiress_out}}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            disabled
            v-if="scope.row.expiress_out !== null && new Date(scope.row.expiress_out).getTime() > Date.now()"
            @click="getAccessToken(scope.row)">
            已授权
          </el-button>
          <el-button
            v-else
            size="mini"
            type="primary"
            @click="getAccessToken(scope.row)">
            去授权
          </el-button>
          <el-button
            size="mini"
            type="primary"
            @click="deleteShop(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="添加"
      :visible.sync="AddShopDrawer"
      :before-close="handleAddDrawerClose"
      size="30%">
      <div class="m-tabs-content">
        <el-row style="margin-bottom: .2rem;">
          <el-col :span="6" :offset="1" class="m-label" style="line-height: .7rem">店铺名称</el-col>
          <el-col :span="16">
            <el-input
              placeholder="请输入店铺名称"
              :size="inputSize"
              v-model="addShopData.shop_name"
              clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="1" class="m-label" style="line-height: .7rem">店铺账号</el-col>
          <el-col :span="16">
            <el-input
              placeholder="请输入店铺账号"
              :size="inputSize"
              v-model="addShopData.shop_account"
              clearable>
            </el-input>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAddShop">保存</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'PddCallback',
  data () {
    return {
      authShop: [],
      AddShopDrawer: false,
      addShopData: {
        shop_name: '',
        shop_account: ''
      },
      inputSize: 'small',
      shop_list: []
    }
  },
  mounted () {
    this.loadCodeUrl()
    this.getDetailData()
  },
  methods: {
    // 授权
    getAccessToken () {
      var url = 'https://fuwu.pinduoduo.com/service-market/auth?response_type=code&client_id=4342c19c0d804ab9849fd08d2050a385&redirect_uri=https://admin.qiyehuo.com/pdd_auth_callback&state=1234'
      window.open(url)
    },
    loadCodeUrl () {
      let code = this.$route.query.code
      this.$axios.post('api/tyc_order/pdd_auth_token', {code: code}
      )
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.authShop = data.data.authShop
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleAddOpenShop () {
      this.AddShopDrawer = true
    },
    handleAddShop () {
      if (!this.addShopData.shop_name) {
        this.$message.error('店铺名称不能为空')
        return
      }
      if (!this.addShopData.shop_account) {
        this.$message.error('店铺名称不能为空')
        return
      }
      this.$axios.post('/api/shop/shop_create', {data: this.addShopData})
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getDetailData()
            this.AddShopDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleAddDrawerClose () {
      this.AddShopDrawer = false
    },
    getDetailData () {
      this.$axios.get('/api/shop/shop_list')
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.shop_list = data.data.data.data
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    deleteShop (row) {
      this.$axios.post('/api/shop/shop_delete', {data: row.id})
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getDetailData()
            this.AddShopDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  }
}
</script>

<style  scoped>
.smscate {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
.addCon{
  margin-left: .4rem;
  margin-top: .4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/pdd_auth_callback/PddCallback.vue